import Header from '../Header/Header';
import React, { useState, useEffect } from 'react'
import './index.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { Formik, Form, ErrorMessage } from 'formik';
import { PacsFormSchema } from "./schema"
import { Loader, SuccessModal } from '@ohif/ui';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls, _pacsUrls } from '@custom/Utils/constants/apiUrls';
import { customStyle } from '@custom/Utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import addEditPac from '@custom/rtk-apis/Setting/addEditPAC';
import { closePACModal } from '@custom/store/slices/Setting/addEditPacSlice';
import { servicesManager } from '../../app/src/App';
import {useTheme} from '../../ui/src/contextProviders'

const AddEditPacs = () => {

  const [edit, setIsEdit] = useState(false)
  const [modal, setModal] = useState(false);
  const [title, setTitle] = useState('');
  const navigate = useNavigate();
  const location = useLocation()
  const dispatch = useDispatch<AppDispatch>();
  const { pacsData } = location?.state || {}
  const { status, loading, result, msg } = useSelector((state: RootState) => state?.addEditPACResponse);
  const { uiNotificationService } = servicesManager.services
  const handleSave = async (values) => {
    let obj = {
      aeTitle: values.aeTitle,
      localPacsAddress: values.localPacsAddress,
      kcClientId: values.kcClientId,
      kcClientSecret: values.kcClientSecret,
      kcURL: values.kcURL,
    }
    if (edit) {
      obj['_id'] = pacsData?._id
    }
    dispatch(addEditPac(obj))

  }
  const cancel = () => {
    navigate("/pacs");
  }
  let initialValues = {
    _id: pacsData?._id || '',
    aeTitle: pacsData?.aeTitle || '',
    localPacsAddress: pacsData?.localPacsAddress || '',
    kcClientId: pacsData?.kcClientId || '',
    kcClientSecret: pacsData?.kcClientSecret || '',
    kcURL: pacsData?.kcURL || '',
  }

  useEffect(() => {
    if (pacsData && Object.keys(pacsData).length > 0) {
      setIsEdit(true)
    }
  }, [])
  useEffect(() => {
    const handleStatusChange = async () => {
      if (status === 'SUCCESS') {
        try {
          const response = await apiRequest({
            method: 'POST',
            endUrl: _pacsUrls.updateActivePACSDetail,
            headerType: 'json',
            body: {
              id: pacsData?._id,
              active: false,
            },
          });
          const key = 'local_pacs_access_token'
          // Check and remove from localStorage
          if (localStorage.getItem(key)) {
            localStorage.removeItem(key);
            localStorage.setItem('LOCAL_PACS_INFO', JSON.stringify([]));
          }
          // Check and remove from sessionStorage
          if (sessionStorage.getItem(key)) {
            sessionStorage.removeItem(key);
            sessionStorage.setItem('LOCAL_PACS_INFO', JSON.stringify([]));
          }
          setModal(true);
          setTimeout(() => {
            navigate("/pacs");
          }, 500);
        } catch (error) {
          console.error("API request failed", error);
          uiNotificationService.show({
            title: "Error",
            type: "error",
            message: "Failed to update PACS detail.",
            position: "bottomRight",
          });
        }
      } else if (status === 'ERROR') {
        uiNotificationService.show({
          title: "Error",
          type: "error",
          message: msg,
          position: "bottomRight",
        });
      }

      dispatch(closePACModal());
    };

    if (status === 'SUCCESS' || status === 'ERROR') {
      handleStatusChange();
    }
  }, [status]);


  const isDarkMode = useTheme();

  return (
    <>
      <div className='pacs page page__full' style={
        isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header isBack={true} title={edit ? 'Edit PACS' : 'Add PACS'}></Header>
        <div className='page__body'>
          <div className='details'>
            <div className='form form--innersec'>
              <section className='form__section'>
                <h1 className='form__section__title'>PACS Details</h1>
                <Formik
                  initialValues={initialValues}
                  validationSchema={PacsFormSchema}
                  onSubmit={handleSave}
                >
                  {({
                    errors,
                    values,
                    handleChange,
                    handleBlur,
                    touched,
                    setFieldValue,
                    setFieldTouched,
                  }) => {
                    return (
                      <Form>
                        <div className="formRow formRow__2">
                          <div className='formCol'>
                            <div className='formRow formRow__2'>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label className='form__label' htmlFor='aeTitle'>
                                    AE Title
                                    <span className='required-asterisk'>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="aeTitle"
                                    name="aeTitle"
                                    placeholder="Ae Title"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.aeTitle}
                                    className="form__input form__input--sm"
                                    autoComplete='off'
                                  />
                                  <ErrorMessage name='aeTitle' component='div' className='error text-error' />
                                </div>
                              </div>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label className='form__label' htmlFor='localPacsAddress'>
                                    Local PACS Address
                                    <span className='required-asterisk'>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="localPacsAddress"
                                    name="localPacsAddress"
                                    placeholder="Local PACS Address"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.localPacsAddress}
                                    className="form__input form__input--sm"
                                    autoComplete='off'
                                  />
                                  <ErrorMessage name="localPacsAddress" component="div" className="error text-error" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className='formCol'>
                            <div className='formRow formRow__2'>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label className='form__label' htmlFor='kcClientSecret'>
                                    Keycloak Client Secret
                                    <span className='required-asterisk'>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="kcClientSecret"
                                    name="kcClientSecret"
                                    placeholder="Keycloak Client Secret"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.kcClientSecret}
                                    className="form__input form__input--sm"
                                    autoComplete='off'
                                  />
                                  <ErrorMessage name='kcClientSecret' component='div' className='error text-error' />
                                </div>
                              </div>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label className='form__label' htmlFor='kcURL'>
                                    Keycloak URL
                                    <span className='required-asterisk'>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="kcURL"
                                    name="kcURL"
                                    placeholder="Keycloak URL"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.kcURL}
                                    className="form__input form__input--sm"
                                    autoComplete='off'
                                  />
                                  <ErrorMessage name='kcURL' component='div' className='error text-error' />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='formRow formRow__2'>
                          <div className='formCol'>
                            <div className='formRow formRow__2'>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label className='form__label' htmlFor='kcClientId'>
                                    Keycloak Client ID
                                    <span className='required-asterisk'>*</span>
                                  </label>
                                  <input
                                    type="text"
                                    id="kcClientId"
                                    name="kcClientId"
                                    placeholder="Keycloak Client ID"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.kcClientId}
                                    className="form__input form__input--sm"
                                    autoComplete='off'
                                  />
                                  <ErrorMessage name='kcClientId' component='div' className='error text-error' />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className='btn__group'>
                          <button className='btn btn__white' onClick={cancel}>
                            Cancel
                          </button>
                          <button className='btn btn__primary' type='submit'>
                            {edit ? 'Update' : 'Save'}
                          </button>
                        </div>
                      </Form>

                    )
                  }}
                </Formik>
              </section>
            </div>
          </div>
        </div>
      </div>

      <SuccessModal
        isSuccessModalOpen={modal}
        title={msg}
        handleCloseModal={() => setModal(false)}
      />
      <Loader isLoaderOpen={loading}></Loader>
    </>

  )
}



export default AddEditPacs
